// extracted by mini-css-extract-plugin
export var address = "site-footer-module--address--KxhQs";
export var icon = "site-footer-module--icon--p1QhQ";
export var legalFooter = "site-footer-module--legalFooter--V7alX";
export var logo = "site-footer-module--logo---DKc9";
export var privacyTermsDivider = "site-footer-module--privacyTermsDivider--gelIl";
export var siteFooter = "site-footer-module--siteFooter--utIZq";
export var socialIcons = "site-footer-module--socialIcons--c+EYg";
export var visitButton = "site-footer-module--visitButton--dudz0";